import CropRounded from '@mui/icons-material/CropRounded';
import DeleteOutlineRounded from '@mui/icons-material/DeleteOutlineRounded';
import EditRounded from '@mui/icons-material/EditRounded';
import FlipCameraIosRounded from '@mui/icons-material/FlipCameraIosRounded';
import Rotate90DegreesCcwRounded from '@mui/icons-material/Rotate90DegreesCcwRounded';
import { SpeedDial, SpeedDialAction } from '@mui/material';

interface CaptureActionsProps {
  handleRemove?: () => any;
  handleRetake?: () => any;
  handleRotate?: () => any;
  handleCrop?: () => any;
  direction: 'up' | 'left';
}

export const CaptureActions = ({
  handleCrop,
  handleRemove,
  handleRetake,
  handleRotate,
  direction = 'left',
}: CaptureActionsProps) => {
  const actions = [
    {
      title: 'Remove',
      icon: <DeleteOutlineRounded sx={{ width: 24, height: 24 }} />,
      onClick: handleRemove,
    },
    {
      title: 'Retake',
      icon: <FlipCameraIosRounded sx={{ width: 24, height: 24 }} />,
      onClick: handleRetake,
    },
    {
      title: 'Rotate',
      icon: <Rotate90DegreesCcwRounded sx={{ width: 24, height: 24 }} />,
      onClick: handleRotate,
    },
    {
      title: 'Crop',
      icon: <CropRounded sx={{ width: 24, height: 24 }} />,
      onClick: handleCrop,
    },
  ];

  return (
    <SpeedDial
      ariaLabel="actions"
      direction={direction}
      icon={<EditRounded sx={{ width: 24, height: 24 }} />}
      sx={{ '& .MuiSpeedDial-fab': { width: 48, height: 48 }, position: 'absolute', right: 40, bottom: 40 }}
    >
      {actions.map((action) => {
        if (!action.onClick) return null;

        return (
          <SpeedDialAction
            onClick={action.onClick}
            key={action.title}
            icon={action.icon}
            slotProps={{
              tooltip: {
                title: action.title,
                placement: 'top',
              },
              fab: { color: 'default' },
            }}
          />
        );
      })}
    </SpeedDial>
  );
};
